import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=4b464c06&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b464c06')) {
      api.createRecord('4b464c06', component.options)
    } else {
      api.reload('4b464c06', component.options)
    }
    module.hot.accept("./breadcrumb.vue?vue&type=template&id=4b464c06&", function () {
      api.rerender('4b464c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
export default component.exports